import React, {Component} from 'react';
import {Router} from 'react-router-dom';
import {Provider} from 'react-redux';
import {SnackbarProvider} from 'notistack';
import withStyles from '@material-ui/core/styles/withStyles';
import globalStyles from '../with-root/global-styles';
import withRoot from '../with-root';
import store from '../store';
import App from './app';

import {History} from 'history';
import ErrorBoundary from '../components/error-boundary';

type IProps = {
    history: History;
};

class Root extends Component<IProps> {
    render() {
        return (
            <Provider store={store}>
                <SnackbarProvider>
                    <Router history={this.props.history}>
                        <ErrorBoundary>
                            <App />
                        </ErrorBoundary>
                    </Router>
                </SnackbarProvider>
            </Provider>
        );
    }
}

export default withStyles(globalStyles)(withRoot(Root));
